import { gql } from '@apollo/client';

export const AddressSuggestion = gql`
  query AddressSuggestion($query: String!) {
    addressSuggestion(input: { query: $query, count: 20 })
      @rest(type: "String", path: "/address", method: "POST", endpoint: "suggestions") {
      suggestions
      errors {
        ...Error
      }
    }
  }
`;

export const LegalSuggestion = gql`
  query legalSuggestion($query: String!, $type: String) {
    legalSuggestion(input: { query: $query, count: 20, type: $type })
      @rest(type: "String", path: "/party", method: "POST", endpoint: "suggestions") {
      suggestions
      errors {
        ...Error
      }
    }
  }
`;
